export default "assets/images/home-logo-78729170.svg";